import { AnfrageNavigationFormComponent, MoveDirection } from '@/core/components/anfrage-navigation-form/anfrage-navigation-form.component';
import { FinanceDataDisplayModelFormGroup } from './../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/finance-data-display-model';
import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { StateService } from '@/core/services/state.service';
import { AnfrageService } from '@/api/service-index';
import { FinanceDataDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/finance-data-display-model';
import { SectionService } from '@/core/services/section.service';
import { AbschnittDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model';
import { GlobalEnumerationsAceFormulartyp } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enumerations-ace-formulartyp';
import { DocumentDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/document-display-model';
import { PortalContextService } from '@/core/services/portal-context.service';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { BankdataDisplayModel } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Finance/bankdata-display-model';
import { removeIbanFormatting } from '@/core/utils/bankdata-utils';

@Component({
    selector: 'finance-data-process-step',
    templateUrl: './finance-data-process-step.component.html',
    styleUrls: ['./finance-data-process-step.component.scss'],
    standalone: false
})
export class FinanceDataProcessStepComponent extends AnfrageNavigationFormComponent {
  
  public financeDataProcessStepForm: FinanceDataDisplayModelFormGroup;
  public financeData: FinanceDataDisplayModel
  
  public get formGroup(): FormGroup<any> {
    return this.financeDataProcessStepForm;
  }

  public get finanzplanDocumentId(): string {
    return this.financeData?.finanzierungsplanDocId || '';
  }

  public get showimport(): boolean {
    let abschnitt: AbschnittDisplayModel | null = this.sectionService.current();
    return abschnitt != null && abschnitt.formularTyp == GlobalEnumerationsAceFormulartyp.FinanzierungmitFPImport;
  }

  constructor(protected sectionService: SectionService, protected route: ActivatedRoute, protected router: Router, protected loadingAnimationService: LoadingAnimationService, protected anfrageService: AnfrageService, protected stateService: StateService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) {
    super(sectionService, router, route, portalContextService);

    this.financeData = this.route.snapshot.data.financeData;

    this.financeDataProcessStepForm = FinanceDataDisplayModelFormGroup.Instance;

    this.financeDataProcessStepForm.reset();

    this.financeDataProcessStepForm.patchValue(this.financeData);
  }
  
  public save(shouldSave: boolean, moveDirection: MoveDirection): void {
    let financeDataModel = this.financeDataProcessStepForm.getRawValue() as FinanceDataDisplayModel;
    removeIbanFormatting(financeDataModel.bankdata);

    if (shouldSave && this.financeDataProcessStepForm.dirty) {
        delete this.portalContextService.CurrentAnfrage.financeData;
        this.financeDataProcessStepForm.markAsPristine();
        if (moveDirection != MoveDirection.STAY) {
          if (this.canceledRoute) {
            this.router.navigateByUrl(this.canceledRoute);
          } else {
            this.move(moveDirection);
          }
        }
        let subscription = this.anfrageService.apiAnfrageAnfrageIdFinanceDataPatch({ anfrageId: this.anfrage.id, body: financeDataModel })
        .subscribe(() => {
          this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
            this.stateService.ValidationErrors = result;
          })

          if (this.portalContextService.CurrentAnfrage)
            this.portalContextService.CurrentAnfrage.financeData = financeDataModel;

          this.financeDataProcessStepForm.markAsPristine();
        }, (error) => {
          this.financeDataProcessStepForm.markAsDirty();
          throw error;
        });

      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
      this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.financeDataProcessStepForm.markAsPristine();
      this.move(moveDirection);
    }

  }

  public onDocumentUploaded(docModel: DocumentDisplayModel) {
    let subscription = this.anfrageService.apiAnfrageAnfrageIdFinanceDataGet({ anfrageId: this.anfrage.id }).subscribe(response => {
      if (response) {
        this.financeDataProcessStepForm.patchValue(response);

        this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
          this.stateService.ValidationErrors = result;
        })

        if (this.portalContextService.CurrentAnfrage)
            this.portalContextService.CurrentAnfrage.financeData = response;

        this.financeDataProcessStepForm.markAsPristine();
      }
    });

    this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }
}
